'use strict';
/* tslint:disable */
/* eslint-disable */
/**
 * Attachments API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, '__esModule', { value: true });
exports.instanceOfErrorResponse = instanceOfErrorResponse;
exports.ErrorResponseFromJSON = ErrorResponseFromJSON;
exports.ErrorResponseFromJSONTyped = ErrorResponseFromJSONTyped;
exports.ErrorResponseToJSON = ErrorResponseToJSON;
const runtime_1 = require('../runtime');
/**
 * Check if a given object implements the ErrorResponse interface.
 */
function instanceOfErrorResponse(value) {
    let isInstance = true;
    return isInstance;
}
function ErrorResponseFromJSON(json) {
    return ErrorResponseFromJSONTyped(json, false);
}
function ErrorResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        success: !(0, runtime_1.exists)(json, 'success')
            ? undefined
            : json['success'],
        message: !(0, runtime_1.exists)(json, 'message')
            ? undefined
            : json['message'],
    };
}
function ErrorResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        success: value.success,
        message: value.message,
    };
}
